package org.example.project.screens_cus_mobile.we

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import org.example.project.dashboard.DashboardTheme
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.example.project.settings.LumaticaCheckbox
import org.example.project.utils.All
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun CUSMobileWEKontrolleScreen(
    auftrag: All,
    abschlussAuftraege: List<All> = listOf(auftrag),
    kontrolleDefinitionen: List<All>,
    onZurueck: () -> Unit,
    onAbschliessen: suspend (All, String, Map<String, String>, String) -> Boolean,
    onAktuellerAuftragChange: (All) -> Unit = {},
    onFertig: () -> Unit = {}
) {
    val scope = rememberCoroutineScope()
    var abschlussIndex by remember(auftrag.id) { mutableStateOf(0) }
    val offeneAbschlussAuftraege = remember(auftrag.id) {
        abschlussAuftraege.ifEmpty { listOf(auftrag) }
    }
    val abschlussAuftrag = offeneAbschlussAuftraege.getOrElse(abschlussIndex) { offeneAbschlussAuftraege.last() }
    val antworten = remember(auftrag.id) { mutableStateMapOf<String, String>() }
    var istAbschlussSchritt by remember(auftrag.id) { mutableStateOf(kontrolleDefinitionen.isEmpty()) }
    var leergut by remember(abschlussAuftrag.id) {
        mutableStateOf(abschlussAuftrag.mobilPalettenAusgang)
    }
    var palettenGetauscht by remember(abschlussAuftrag.id) {
        mutableStateOf(abschlussAuftrag.mobilPalettenGetauscht)
    }
    var abschlussBestaetigung by remember(abschlussAuftrag.id) { mutableStateOf(false) }
    var palettenUnbeschaedigt by remember(abschlussAuftrag.id) { mutableStateOf(abschlussAuftrag.mobilWePalettenUnbeschaedigt.takeIf { it > 0 }?.toString().orEmpty()) }
    var palettenFehlmenge by remember(abschlussAuftrag.id) { mutableStateOf(abschlussAuftrag.mobilWePalettenFehlmenge.takeIf { it > 0 }?.toString().orEmpty()) }
    var palettenBruch by remember(abschlussAuftrag.id) { mutableStateOf(abschlussAuftrag.mobilWePalettenBruch.takeIf { it > 0 }?.toString().orEmpty()) }
    var palettenUeberzaehlig by remember(abschlussAuftrag.id) { mutableStateOf(abschlussAuftrag.mobilWePalettenUeberzaehlig.takeIf { it > 0 }?.toString().orEmpty()) }
    var busy by remember(auftrag.id) { mutableStateOf(false) }
    var validationError by remember(auftrag.id) { mutableStateOf("") }
    val sortierteKontrollen = remember(kontrolleDefinitionen) {
        kontrolleDefinitionen.sortedWith(cusMobileWEKontrollComparator())
    }

    LaunchedEffect(abschlussAuftrag.id, abschlussAuftrag.lfdNr) {
        onAktuellerAuftragChange(abschlussAuftrag)
    }

    LaunchedEffect(auftrag.id, sortierteKontrollen.size) {
        antworten.clear()
        abschlussIndex = 0
        istAbschlussSchritt = sortierteKontrollen.isEmpty()
        sortierteKontrollen.forEach { def ->
            val key = cusMobileWEKontrollKey(def)
            antworten[key] = auftrag.palettenWerte[key].orEmpty().ifBlank {
                if (def.kontrollTyp.equals("checkbox", true)) "\u2B1C" else ""
            }
        }
    }

    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(12.px)
            width(100.percent)
            height(100.percent)
            minHeight(0.px)
            flex(1)
        }
    }) {
        if (!istAbschlussSchritt) {
            Div({
                style {
                    flex(1)
                    minHeight(0.px)
                    overflowY("auto")
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    alignItems(AlignItems.Center)
                    gap(12.px)
                    paddingBottom(4.px)
                }
            }) {
                Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(16.px); fontWeight("900") } }) {
                    Text("Wareneingang kontrollieren")
                }
                sortierteKontrollen.forEach { def ->
                    val key = cusMobileWEKontrollKey(def)
                    val wert = antworten[key].orEmpty()
                    Div({
                        style {
                            padding(14.px)
                            width(100.percent)
                            borderRadius(8.px)
                            backgroundColor(DashboardTheme.SURFACE_CARD)
                            property("border", "1px solid rgba(255,255,255,0.08)")
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Column)
                            alignItems(AlignItems.FlexStart)
                            gap(10.px)
                            boxSizing("border-box")
                        }
                    }) {
                        Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(16.px); fontWeight("900"); lineHeight("1.3"); textAlign("left") } }) {
                            Text(cusMobileWEKontrollLabel(def))
                        }
                        CUSMobileWEKontrollField(def, wert) {
                            antworten[key] = it
                            validationError = ""
                        }
                    }
                }
                if (validationError.isNotBlank()) {
                    Span({ style { color(DashboardTheme.ACCENT); fontSize(13.px); fontWeight("700") } }) {
                        Text(validationError)
                    }
                }
            }

            CUSMobileWEFlowFooter(
                leftLabel = "Zurück",
                rightLabel = "Weiter",
                busy = busy,
                onZurueck = onZurueck,
                onWeiter = {
                    val offen = sortierteKontrollen.firstOrNull { def ->
                        cusMobileWEKontrollAntwortFehlt(def, antworten[cusMobileWEKontrollKey(def)].orEmpty())
                    }
                    if (offen != null) {
                        validationError = "Bitte alle Prüfschritte bestätigen."
                    } else {
                        istAbschlussSchritt = true
                        validationError = ""
                    }
                }
            )
        } else {
            Div({ style { flex(1); minHeight(0.px); width(100.percent); position(Position.Relative) } }) {
                Div({
                    style {
                        position(Position.Absolute)
                        top(0.px)
                        left(0.px)
                        width(100.percent)
                        textAlign("center")
                        color(DashboardTheme.TEXT_LIGHT)
                        fontSize(18.px)
                        fontWeight("900")
                    }
                }) {
                    Text(
                        if (offeneAbschlussAuftraege.size > 1) {
                            "WE Abschluss ${abschlussIndex + 1}/${offeneAbschlussAuftraege.size}"
                        } else if (abschlussBestaetigung) {
                            "WE Abschluss bestätigen"
                        } else {
                            "WE Abschluss"
                        }
                    )
                }
                Div({
                    style {
                        position(Position.Absolute)
                        top(50.percent)
                        left(50.percent)
                        property("transform", "translate(-50%, -50%)")
                        width(100.percent)
                        maxWidth(360.px)
                        maxHeight(100.percent)
                        overflowY("auto")
                        paddingBottom(6.px)
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        alignItems(AlignItems.Center)
                        gap(24.px)
                        textAlign("center")
                        boxSizing("border-box")
                    }
                }) {
                    if (!abschlussBestaetigung) {
                        CUSMobileWEAbschlussScreen(
                            leergut = leergut,
                            palettenGetauscht = palettenGetauscht,
                            onPalettenGetauschtChange = {
                                palettenGetauscht = it
                                if (!it) leergut = ""
                                validationError = ""
                            },
                            onLeergutChange = {
                                leergut = it
                                validationError = ""
                            }
                        )
                    } else {
                        CUSMobileWEBestaetigungScreen(
                            sollPaletten = abschlussAuftrag.palettenanzahl.coerceAtLeast(0),
                            unbeschaedigt = palettenUnbeschaedigt,
                            onUnbeschaedigtChange = {
                                palettenUnbeschaedigt = it
                                validationError = ""
                            },
                            fehlmenge = palettenFehlmenge,
                            onFehlmengeChange = {
                                palettenFehlmenge = it
                                validationError = ""
                            },
                            bruch = palettenBruch,
                            onBruchChange = {
                                palettenBruch = it
                                validationError = ""
                            },
                            ueberzaehlig = palettenUeberzaehlig,
                            onUeberzaehligChange = {
                                palettenUeberzaehlig = it
                                validationError = ""
                            }
                        )
                    }
                    if (validationError.isNotBlank()) {
                        Span({ style { color(DashboardTheme.ACCENT); fontSize(13.px); fontWeight("700") } }) {
                            Text(validationError)
                        }
                    }
                }
            }

            CUSMobileWEFlowFooter(
                leftLabel = "Zurück",
                rightLabel = if (abschlussBestaetigung) {
                    if (busy) "Speichere..." else "WE Abschließen"
                } else {
                    "Weiter"
                },
                busy = busy,
                onZurueck = {
                    if (busy) return@CUSMobileWEFlowFooter
                    if (abschlussBestaetigung) {
                        abschlussBestaetigung = false
                        validationError = ""
                    } else {
                        istAbschlussSchritt = false
                    }
                },
                onWeiter = {
                    if (busy) return@CUSMobileWEFlowFooter
                    if (!abschlussBestaetigung) {
                        if (palettenGetauscht && leergut.toIntOrNull() == null) {
                            validationError = "Bitte Anzahl der getauschten Paletten eingeben."
                            return@CUSMobileWEFlowFooter
                        }
                        abschlussBestaetigung = true
                        validationError = ""
                        return@CUSMobileWEFlowFooter
                    }

                    val unbeschaedigt = palettenUnbeschaedigt.toIntOrNull()
                    val fehlmenge = palettenFehlmenge.toIntOrNull()
                    val bruch = palettenBruch.toIntOrNull()
                    val ueberzaehlig = palettenUeberzaehlig.toIntOrNull()
                    val soll = abschlussAuftrag.palettenanzahl.coerceAtLeast(0)
                    if (unbeschaedigt == null || fehlmenge == null || bruch == null || ueberzaehlig == null) {
                        validationError = "Bitte alle Palettenfelder eingeben."
                        return@CUSMobileWEFlowFooter
                    }
                    if (unbeschaedigt + fehlmenge + bruch != soll) {
                        validationError = "Die Summe muss $soll Paletten ergeben."
                        return@CUSMobileWEFlowFooter
                    }
                    val istPaletten = (unbeschaedigt + bruch).toString()
                    busy = true
                    scope.launch {
                        val gespeichert = onAbschliessen(
                            abschlussAuftrag,
                            if (palettenGetauscht) leergut else "",
                            antworten.toMap() + mapOf(
                                "mobil.weAbschlussArt" to if (fehlmenge > 0) "unvollständig" else "vollständig",
                                "mobil.palettenGetauscht" to palettenGetauscht.toString(),
                                "mobil.wePalettenUnbeschädigt" to unbeschaedigt.toString(),
                                "mobil.wePalettenFehlmenge" to fehlmenge.toString(),
                                "mobil.wePalettenBruch" to bruch.toString(),
                                "mobil.wePalettenÜberzählig" to ueberzaehlig.toString(),
                                "mobil.weUnvollständigFehlPaletten" to fehlmenge.toString(),
                                "mobil.weUnvollständigIstPaletten" to istPaletten
                            ).filterValues { it.isNotBlank() },
                            istPaletten
                        )
                        if (!gespeichert) {
                            validationError = "WE Abschluss konnte nicht gespeichert werden."
                        } else if (abschlussIndex + 1 < offeneAbschlussAuftraege.size) {
                            abschlussIndex += 1
                            abschlussBestaetigung = false
                            validationError = ""
                        } else {
                            onFertig()
                        }
                        busy = false
                    }
                }
            )



        }
    }
}

@Composable
private fun CUSMobileWEKontrollField(definition: All, wert: String, onValueChange: (String) -> Unit) {
    definition.beschreibung?.takeIf { it.isNotBlank() }?.let { text ->
        P({ style { margin(0.px); color(DashboardTheme.TEXT_MUTED); fontSize(13.px); lineHeight("1.5") } }) {
            Text(text)
        }
    }
    val options = definition.kontrollOptions.filter { it.isNotBlank() }
    when {
        options.isNotEmpty() -> {
            Select({
                attr("value", wert)
                style {
                    height(56.px)
                    width(100.percent)
                    padding(0.px, 14.px)
                    color(DashboardTheme.TEXT_LIGHT)
                    backgroundColor(Color("rgba(255,255,255,0.04)"))
                    property("border", "1px solid rgba(255,255,255,0.14)")
                    borderRadius(8.px)
                    property("box-sizing", "border-box")
                    fontSize(17.px)
                    fontWeight("900")
                }
                onInput { onValueChange(it.value.orEmpty()) }
            }) {
                Option("") { Text("Auswahl") }
                options.forEach { option -> Option(option) { Text(option) } }
            }
        }
        definition.kontrollTyp.equals("checkbox", true) -> {
            Div({ style { width(100.percent); display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center) } }) {
                LumaticaCheckbox(
                    checked = cusMobileWEKontrollCheckboxChecked(wert),
                    onChange = { checked -> onValueChange(if (checked) "\u2705" else "\u2B1C") },
                    fontSizePx = 30
                )
            }
        }
        cusMobileWEIstTemperaturKontrolle(definition) -> {
            Div({
                style {
                    height(56.px)
                    width(100.percent)
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    backgroundColor(Color("rgba(255,255,255,0.04)"))
                    property("border", "1px solid rgba(255,255,255,0.14)")
                    borderRadius(8.px)
                    property("box-sizing", "border-box")
                }
            }) {
                Input(InputType.Text) {
                    value(wert)
                    attr("placeholder", "Temperatur")
                    style {
                        height(100.percent)
                        flex(1)
                        minWidth(0.px)
                        padding(0.px, 12.px)
                        color(DashboardTheme.TEXT_LIGHT)
                        backgroundColor(Color.transparent)
                        property("border", "0")
                        property("outline", "0")
                        property("box-sizing", "border-box")
                        fontSize(17.px)
                        fontWeight("900")
                        textAlign("center")
                    }
                    onInput { onValueChange(it.value) }
                }
                Span({ style { paddingRight(14.px); color(DashboardTheme.TEXT_LIGHT); fontSize(17.px); fontWeight("900") } }) {
                    Text("°C")
                }
            }
        }
        else -> {
            Input(InputType.Text) {
                value(wert)
                attr("placeholder", "Antwort eingeben")
                style {
                    height(56.px)
                    width(100.percent)
                    padding(0.px, 14.px)
                    color(DashboardTheme.TEXT_LIGHT)
                    backgroundColor(Color("rgba(255,255,255,0.04)"))
                    property("border", "1px solid rgba(255,255,255,0.14)")
                    borderRadius(8.px)
                    property("box-sizing", "border-box")
                    fontSize(17.px)
                    fontWeight("900")
                    textAlign("center")
                }
                onInput { onValueChange(it.value) }
            }
        }
    }
}

@Composable
private fun CUSMobileWEFlowFooter(
    leftLabel: String,
    rightLabel: String,
    busy: Boolean,
    onZurueck: () -> Unit,
    onWeiter: () -> Unit
) {
    Div({ style { width(100.percent); display(DisplayStyle.Flex); boxSizing("border-box") } }) {
        Div({ style { flex(1); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center) } }) {
            Div({ style { width(150.px); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center) } }) {
                LumaticaButton(leftLabel, onZurueck, variant = LumaticaButtonVariant.Standard, heightPx = 42, enabled = !busy)
            }
        }
        Div({ style { flex(1); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center) } }) {
            Div({ style { width(150.px); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center) } }) {
                LumaticaButton(rightLabel, onWeiter, variant = LumaticaButtonVariant.Action, heightPx = 42, enabled = !busy)
            }
        }
    }
}

private fun cusMobileWEKontrollComparator(): Comparator<All> =
    compareBy<All> { it.abfragePrio.takeIf { prio -> prio > 0 } ?: it.kontrollId.toIntOrNull() ?: it.id.toIntOrNull() ?: Int.MAX_VALUE }
        .thenBy { it.kontrollId.toIntOrNull() ?: Int.MAX_VALUE }
        .thenBy { it.kontrollId.ifBlank { it.id } }

private fun cusMobileWEKontrollCheckboxChecked(value: String): Boolean =
    value == "\u2705" || value.equals("true", ignoreCase = true) || value.equals("ja", ignoreCase = true)

private fun cusMobileWEKontrollAntwortFehlt(definition: All, value: String): Boolean =
    definition.kontrollPflicht && if (definition.kontrollTyp.equals("checkbox", true)) {
        !cusMobileWEKontrollCheckboxChecked(value)
    } else {
        value.isBlank()
    }

private fun cusMobileWEIstTemperaturKontrolle(definition: All): Boolean {
    val text = listOf(definition.bezeichnung, definition.kontrollBezeichnung).joinToString(" ").lowercase()
    return "temperatur" in text
}

private fun cusMobileWEKontrollKey(definition: All): String =
    "mobil.kontrolle.${definition.id.ifBlank { cusMobileWEKontrollLabel(definition) }}"

private fun cusMobileWEKontrollLabel(definition: All): String =
    definition.kontrollBezeichnung.ifBlank { definition.bezeichnung.ifBlank { definition.id.ifBlank { "Kontrolle" } } }
